import {load,getRef} from './common'

export function loadComments() {
  return load('comments')
}

function purify(obj){
  Object.keys(obj).forEach(key=>{
    if(obj[key]===undefined || obj[key]==='')
      delete obj[key]
  })
  obj.timestamp = obj.timestamp || Date.now()
  return obj
}

export function saveComment(comment) {
  comment = purify(comment)
  let {timestamp,routeId} = comment
  getRef('comments').child(routeId).child(timestamp).set(comment)
}

export function deleteComment(comment) {
  let {timestamp,routeId} = comment
  if(!timestamp)
    return
  getRef('comments').child(routeId).child(timestamp).remove()
}



/** WEBPACK FOOTER **
 ** ./src/app/actions/comments.js
 **/